<div class="row">
  <div class="col-lg-6">
    <app-user-select
      bindValue="id"
      [ctrl]="receiverForm.get('user_id')"
      [multiple]="false"
      (selected)="onUserSelect($event)"
      i18n-matTooltip
      matTooltip="Select which user will receive all notification emails."
      i18n-label
      label="Notifications Receiver"
    ></app-user-select>
  </div>
</div>

<div [formGroup]="form" class="d-flex flex-column gap-3">
  <div>
    <mat-checkbox i18n formControlName="sent">Notify me when a document is sent to a recipient.</mat-checkbox>
  </div>
  <div>
    <mat-checkbox i18n formControlName="viewed"
      >Notify me when a document is viewed by a recipient for the first time.</mat-checkbox
    >
  </div>
  <div>
    <mat-checkbox i18n formControlName="signed">Notify me when a document is signed by a recipient. </mat-checkbox>
  </div>
  <div>
    <mat-checkbox i18n formControlName="declined">Notify me when a document is declined by a recipient. </mat-checkbox>
  </div>
  <div>
    <mat-checkbox i18n formControlName="expired">Notify me when a document expires.</mat-checkbox>
  </div>
  <div>
    <mat-checkbox i18n formControlName="failed">Notify me when a document delivery fails.</mat-checkbox>
  </div>
  <div class="d-flex align-items-center gap-2" formGroupName="before_expired">
    <mat-checkbox formControlName="checked" i18n>Notify me</mat-checkbox>
    <mat-form-field2 [showLabel]="false" style="width: 10rem">
      <input type="number" matInput formControlName="days" />
      <span matSuffix i18n>Days</span>
    </mat-form-field2>
    <mat-form-field2 [showLabel]="false" style="width: 10rem">
      <input type="number" matInput formControlName="hours" />
      <span matSuffix i18n>Hours</span>
    </mat-form-field2>
    <ng-container i18n>before expiration.</ng-container>
  </div>
  <div class="d-flex align-items-center gap-2" formGroupName="after_expired">
    <mat-checkbox formControlName="checked" i18n>Notify me</mat-checkbox>
    <mat-form-field2 [showLabel]="false" style="width: 10rem">
      <input type="number" matInput formControlName="days" />
      <span matSuffix i18n>Days</span>
    </mat-form-field2>
    <mat-form-field2 [showLabel]="false" style="width: 10rem">
      <input type="number" matInput formControlName="hours" />
      <span matSuffix i18n>Hours</span>
    </mat-form-field2>
    <ng-container i18n>after expiration.</ng-container>
  </div>
</div>
